module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABX0lEQVQ4jZXTv2tUQRDA8c9bz1MQJLaCgokQSBoD9jaKKdKIhLQWKRRSGCRV1Mbgj0ILf4CGg8DrApEU1wQU7AURYmIhJAj+AYIQQg6iFjsPzschdwPLm52Z7775sVuUZakmY5jFJIbDtosNtPC1Ozh16cfxCpu4jQO8jXUQtk28QLOCGvFtoo3LWMMivtUyG8FjzGEUU+hUGTwN+D6me8CwE757uIJnVQnjuIV1POgB1mUpYm9iPMkNS1joA65kIZjZhKv4HCn2KzvBTCZ5VFvhOB2Oa7FfwevQb+AjhmL/BcMJv/07zgb+hJ5QdPmKiK+kU5RluY19XBygBPiEYwkfMIHzA8AjwbxPeBPGhwMc8EQupZXkZrTlS3K2D/gursePtxo4hUtyTT/+A57DI8zgHebJHZ+XR3MUqxH8C4ehn5Bf6AV5Oi9xB53qAPiJM7HgJI6EvofveI5ltef8F+4eSGeuo2hHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/comment.png
// module id = dHfs
// module chunks = 0